/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconPilcrowLeft = createReactComponent("outline", "pilcrow-left", "IconPilcrowLeft", [["path", { "d": "M11 9h-2a3 3 0 1 1 0 -6h7", "key": "svg-0" }], ["path", { "d": "M11 3v11", "key": "svg-1" }], ["path", { "d": "M15 3v11", "key": "svg-2" }], ["path", { "d": "M3 18h18", "key": "svg-3" }], ["path", { "d": "M6 15l-3 3l3 3", "key": "svg-4" }]]);

export { IconPilcrowLeft as default };
//# sourceMappingURL=IconPilcrowLeft.mjs.map
